import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router";

import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useMe } from "@/hooks/use-auth";
import { useWorkspaces } from "@/hooks/use-workspaces";

import { NumberSequenceCard } from "./number-sequence-card";

export function NumberSequencePage({
  workspaceIdOverride,
  backUrl,
}: {
  workspaceIdOverride?: string;
  backUrl?: string;
} = {}) {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: me } = useMe();
  const workspaceId = workspaceIdOverride ?? id ?? me?.activeWorkspaceId ?? "";

  const { data: workspacesData, isLoading } = useWorkspaces({ per_page: 100 });
  const workspace =
    workspacesData?.items.find((w) => w.id === workspaceId) ?? null;

  const canUpdate =
    Boolean(me?.permissions?.includes("workspaces.update")) ||
    Boolean(me?.roleNames?.includes("Franchisor")) ||
    Boolean(me?.roleNames?.includes("Developer"));

  function goBack() {
    if (backUrl) {
      navigate(backUrl);
    } else if (id) {
      navigate("/settings/workspaces");
    } else {
      navigate("/settings/workspace");
    }
  }

  if (isLoading) {
    return (
      <div className="space-y-6">
        <PageHeader
          title="Penomoran Transaksi"
          description="Memuat data konfigurasi penomoran..."
        />
        <Skeleton className="h-64 w-full rounded-xl" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {id ? (
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={goBack}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="text-xl font-semibold">Penomoran Transaksi</h1>
            <p className="text-sm text-muted-foreground">
              Konfigurasi format penomoran urut otomatis (number sequence) untuk
              outlet{" "}
              <span className="font-medium text-foreground">
                {workspace?.name ?? "..."}
              </span>
              .
            </p>
          </div>
        </div>
      ) : (
        <PageHeader
          title="Penomoran Transaksi"
          description={`Konfigurasi format penomoran urut otomatis (number sequence) untuk outlet ${workspace?.name ?? ""}`}
        />
      )}

      <NumberSequenceCard workspaceId={workspaceId} canUpdate={!!canUpdate} />
    </div>
  );
}
